import { toMajorUnit } from '../convert/to-major-unit';

// TODO: revisit the decimal separator approach. The uk-UA locale renders a comma
// (e.g. "0,03"), but some fields require a dot (e.g. prolongation commission on the
// contract page — kopiykas must be separated by a dot only). Consider an opt-in option
// here (e.g. `useDot`) instead of formatting such values manually at each call site.
type FormatCoinsOptions = {
  hideCurrency?: boolean;
};

export const formatCoins = (coins: number, options: FormatCoinsOptions = {}) => {
  const { hideCurrency = false } = options;

  return toMajorUnit(coins).toLocaleString('uk-UA', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: hideCurrency ? 'decimal' : 'currency',
    currency: hideCurrency ? undefined : 'UAH',
  });
};
